.shell{
  min-height:100dvh;
  padding:76px 0 92px;
  background:
    radial-gradient(circle at 12% 8%,rgb(44 88 132 / 32%),transparent 28%),
    linear-gradient(160deg,#07152d,#0b2346 48%,#07162d);
  color:#fff;
}
.appBar{
  position:fixed;
  z-index:80;
  inset:0 0 auto;
  min-height:70px;
  display:grid;
  grid-template-columns:auto minmax(220px,620px) auto;
  align-items:center;
  gap:14px;
  padding:10px max(14px,calc((100vw - 1180px)/2));
  border-bottom:1px solid rgb(255 255 255 / 10%);
  background:rgb(7 21 45 / 78%);
  backdrop-filter:blur(24px) saturate(120%);
}
.brand{
  display:grid;
  border:0;
  background:transparent;
  color:#fff;
  text-align:left;
  cursor:pointer;
}
.brand strong{font-size:23px;letter-spacing:.01em}
.brand span{font-size:9px;letter-spacing:.32em;color:#bfad81}
.search{
  display:grid;
  grid-template-columns:minmax(0,1fr) 42px;
  gap:8px;
}
.search label{
  position:absolute;
  width:1px;
  height:1px;
  overflow:hidden;
  clip:rect(0 0 0 0);
}
.search input{
  min-height:44px;
  border:1px solid rgb(255 255 255 / 13%);
  border-radius:17px;
  padding:0 14px;
  background:rgb(255 255 255 / 7%);
  color:#fff;
  outline:none;
}
.search button,.menuButton{
  min-height:42px;
  border:1px solid rgb(255 255 255 / 14%);
  border-radius:15px;
  background:rgb(255 255 255 / 7%);
  color:#fff;
}
.menuButton{width:42px}
.navigationStack{
  position:fixed;
  z-index:60;
  top:70px;
  left:50%;
  transform:translateX(-50%);
  width:min(820px,calc(100% - 28px));
  display:grid;
  gap:8px;
  padding:8px;
  background:linear-gradient(180deg,rgb(7 21 45 / 70%),rgb(7 21 45 / 20%));
  backdrop-filter:blur(16px);
}
.modeSwitch,.homeSubnav{
  display:grid;
  gap:6px;
}
.modeSwitch{grid-template-columns:repeat(3,1fr)}
.homeSubnav{grid-template-columns:1fr 1fr}
.modeSwitch button,.homeSubnav button{
  min-height:38px;
  border:1px solid rgb(255 255 255 / 12%);
  border-radius:999px;
  background:rgb(255 255 255 / 6%);
  color:#c8d5df;
}
.modeSwitch button[aria-pressed=true],.homeSubnav button[aria-pressed=true]{
  color:#bfad81;
  border-color:rgb(191 173 129 / 30%);
  background:rgb(191 173 129 / 12%);
}
.error,.loading,.notice{
  position:fixed;
  z-index:95;
  left:50%;
  transform:translateX(-50%);
  width:min(720px,calc(100% - 28px));
  padding:12px 14px;
  border:1px solid rgb(255 255 255 / 12%);
  border-radius:16px;
  background:rgb(7 21 45 / 92%);
  backdrop-filter:blur(20px);
}
.error{top:146px}
.loading{top:146px;color:#c7d5df}
.notice{
  bottom:94px;
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:14px;
  border-color:rgb(191 173 129 / 30%);
}
.notice button{
  width:30px;
  height:30px;
  border:0;
  border-radius:50%;
  background:rgb(255 255 255 / 8%);
  color:#fff;
}
.homeShell{
  position:relative;
  min-height:calc(100dvh - 76px);
}
.feedViewport{
  height:calc(100dvh - 76px);
  overflow-y:auto;
  scroll-snap-type:y mandatory;
  overscroll-behavior-y:contain;
  scrollbar-width:none;
}
.feedViewport::-webkit-scrollbar{display:none}
.story{
  position:relative;
  min-height:calc(100dvh - 76px);
  scroll-snap-align:start;
  scroll-snap-stop:always;
  background-position:center;
  background-size:cover;
  overflow:hidden;
}
.storyTopline{
  position:absolute;
  z-index:5;
  top:148px;
  left:max(18px,calc((100vw - 1020px)/2));
  right:max(18px,calc((100vw - 1020px)/2));
  display:flex;
  justify-content:space-between;
  align-items:center;
  gap:10px;
}
.storyTopline span,.storyTopline small{
  padding:7px 10px;
  border:1px solid rgb(255 255 255 / 14%);
  border-radius:999px;
  background:rgb(8 24 45 / 58%);
  backdrop-filter:blur(16px);
  font-size:10px;
}
.storyTopline span{color:#bfad81;letter-spacing:.08em}
.storyCopy{
  position:absolute;
  z-index:5;
  left:max(18px,calc((100vw - 1020px)/2));
  right:max(18px,calc((100vw - 1020px)/2));
  bottom:164px;
  max-width:720px;
}
.storyCopy p,.agencyPanel p{
  margin:0;
  color:#bfad81;
  font-size:10px;
  letter-spacing:.12em;
  text-transform:uppercase;
}
.storyCopy h1,.agencyPanel h1{
  margin:7px 0;
  font-family:Georgia,serif;
  font-size:clamp(42px,6vw,78px);
  line-height:.96;
  font-weight:500;
}
.storyCopy>span,.agencyPanel>div>span{
  display:block;
  max-width:650px;
  color:#d7e2e9;
  line-height:1.5;
}
.storyCopy>strong{
  display:block;
  margin-top:12px;
  color:#fff;
  font-size:28px;
}
.storyCopy>small{display:block;margin-top:6px;color:#aebfca}
.agencyPanel{
  position:absolute;
  z-index:5;
  left:max(18px,calc((100vw - 1020px)/2));
  right:max(18px,calc((100vw - 1020px)/2));
  bottom:174px;
  display:grid;
  grid-template-columns:64px minmax(0,1fr);
  gap:14px;
  max-width:760px;
  padding:18px;
  border:1px solid rgb(255 255 255 / 14%);
  border-radius:28px;
  background:rgb(19 42 72 / 48%);
  backdrop-filter:blur(28px) saturate(120%);
}
.avatar{
  width:54px;
  height:54px;
  display:grid;
  place-items:center;
  border-radius:50%;
  background:linear-gradient(145deg,#315f7c,#685fc0);
  font-weight:800;
}
.tags{display:flex;gap:6px;flex-wrap:wrap;margin-top:12px}
.tags b{
  padding:6px 9px;
  border:1px solid rgb(255 255 255 / 13%);
  border-radius:999px;
  background:rgb(5 18 35 / 42%);
  font-size:9px;
}
.scrollActionBar,.scrollActionBarSettling{
  position:fixed;
  z-index:70;
  left:50%;
  bottom:98px;
  transform:translateX(-50%);
  width:min(420px,calc(100vw - 34px));
  display:grid;
  grid-template-columns:repeat(3,minmax(0,1fr));
  gap:6px;
  padding:7px;
  border:1px solid rgb(191 173 129 / 23%);
  border-radius:25px;
  background:rgb(48 73 93 / 28%);
  backdrop-filter:blur(24px) saturate(120%);
  transition:opacity 180ms ease,background-color 180ms ease;
}
.scrollActionBarSettling{
  opacity:.24;
  pointer-events:none;
  background:rgb(48 73 93 / 10%);
}
.scrollActionBar button,.scrollActionBarSettling button{
  min-height:58px;
  display:grid;
  place-items:center;
  align-content:center;
  gap:3px;
  border:0;
  border-radius:18px;
  background:transparent;
  color:#fff;
}
.scrollActionBar button span,.scrollActionBarSettling button span{font-size:22px}
.scrollActionBar button b,.scrollActionBarSettling button b{font-size:8px}
.scrollActionBar button:disabled,.scrollActionBarSettling button:disabled{opacity:.36}
.opportunities,.collectionsPage,.directoryPage,.activityPage{
  width:min(1180px,calc(100% - 28px));
  margin:22px auto 0;
}
.opportunities>p,.collectionsHero p,.directoryPage>header p,.activityPage>p{
  margin:0;
  color:#bfad81;
  font-size:10px;
  letter-spacing:.14em;
}
.opportunities>h1,.collectionsHero h1,.directoryPage>header h1,.activityPage>h1{
  margin:5px 0 16px;
  font-family:Georgia,serif;
  font-size:clamp(38px,5vw,62px);
  font-weight:500;
}
.opportunityGrid{
  display:grid;
  grid-template-columns:repeat(3,1fr);
  gap:12px;
}
.opportunityGrid article{
  min-height:260px;
  display:grid;
  align-content:end;
  padding:20px;
  border:1px solid rgb(255 255 255 / 12%);
  border-radius:24px;
  background:
    radial-gradient(circle at 80% 10%,rgb(60 120 170 / 18%),transparent 35%),
    rgb(255 255 255 / 5%);
}
.opportunityGrid article>span{color:#bfad81;font-size:9px;letter-spacing:.12em}
.opportunityGrid h2{margin:6px 0;font-family:Georgia,serif;font-weight:500}
.opportunityGrid p{color:#adbfcc;line-height:1.5}
.opportunityGrid button{
  min-height:40px;
  border:1px solid rgb(255 255 255 / 12%);
  border-radius:14px;
  background:rgb(255 255 255 / 6%);
  color:#a8b7c2;
}
.collectionsHero,.directoryPage>header{
  display:flex;
  justify-content:space-between;
  align-items:end;
  gap:18px;
  padding:18px;
  border:1px solid rgb(255 255 255 / 12%);
  border-radius:24px;
  background:rgb(255 255 255 / 5%);
  backdrop-filter:blur(18px);
}
.collectionsHero span,.directoryPage>header span{
  display:block;
  max-width:760px;
  color:#aebfca;
}
.collectionsHero button{
  min-height:40px;
  padding:0 14px;
  border:1px solid rgb(255 255 255 / 14%);
  border-radius:14px;
  background:rgb(255 255 255 / 7%);
  color:#fff;
}
.directoryPage>header>strong{font-size:38px;color:#bfad81}
.collectionChips{
  display:flex;
  gap:7px;
  overflow:auto;
  margin:12px 0;
  padding-bottom:4px;
}
.collectionChips button{
  flex:0 0 auto;
  min-height:38px;
  padding:0 14px;
  border:1px solid rgb(255 255 255 / 12%);
  border-radius:999px;
  background:rgb(255 255 255 / 6%);
  color:#c2d0d9;
}
.collectionChips button[aria-pressed=true]{
  background:rgb(191 173 129 / 14%);
  border-color:rgb(191 173 129 / 30%);
  color:#bfad81;
}
.loadingInline{
  padding:14px;
  border:1px solid rgb(255 255 255 / 10%);
  border-radius:16px;
  background:rgb(255 255 255 / 5%);
  color:#aebfca;
}
.collectionOverview{
  display:grid;
  grid-template-columns:repeat(2,1fr);
  gap:10px;
}
.collectionOverview article{
  min-height:180px;
  display:grid;
  align-content:end;
  padding:18px;
  border:1px solid rgb(255 255 255 / 12%);
  border-radius:22px;
  background:linear-gradient(145deg,rgb(33 77 120 / 38%),rgb(8 25 52 / 70%));
}
.collectionOverview strong{font-family:Georgia,serif;font-size:24px;font-weight:500}
.collectionOverview span{font-size:32px;color:#bfad81}
.collectionOverview small{color:#9fb1bd}
.mixedList{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:10px}
.mixedList article{
  overflow:hidden;
  display:grid;
  grid-template-columns:160px minmax(0,1fr);
  border:1px solid rgb(255 255 255 / 12%);
  border-radius:22px;
  background:rgb(255 255 255 / 5%);
}
.mixedThumb{
  min-height:150px;
  background-size:cover;
  background-position:center;
  padding:10px;
}
.mixedThumb span{
  display:inline-flex;
  padding:5px 8px;
  border-radius:999px;
  background:rgb(7 21 45 / 68%);
  font-size:9px;
}
.mixedList article>div:last-child{padding:15px}
.mixedList b{color:#bfad81;font-size:9px}
.mixedList h2{margin:5px 0;font-family:Georgia,serif;font-weight:500}
.mixedList p,.mixedList small{color:#aebfca}
.empty{
  grid-column:1/-1;
  display:grid;
  gap:4px;
  padding:22px;
  border:1px solid rgb(255 255 255 / 10%);
  border-radius:18px;
  background:rgb(255 255 255 / 5%);
  color:#aebfca;
}
.mutualLayout{
  display:grid;
  grid-template-columns:360px minmax(0,1fr);
  min-height:560px;
  overflow:hidden;
  border:1px solid rgb(255 255 255 / 12%);
  border-radius:24px;
  background:rgb(255 255 255 / 4%);
}
.mutualList{
  overflow:auto;
  border-right:1px solid rgb(255 255 255 / 10%);
}
.connection,.connectionActive{
  width:100%;
  display:grid;
  grid-template-columns:48px minmax(0,1fr) auto;
  gap:10px;
  align-items:center;
  padding:11px 12px;
  border:0;
  border-bottom:1px solid rgb(255 255 255 / 8%);
  color:#fff;
  text-align:left;
}
.connection{background:transparent}
.connectionActive{background:rgb(255 255 255 / 8%)}
.connection>span:nth-child(2),.connectionActive>span:nth-child(2){display:grid;gap:3px}
.connection small,.connectionActive small{color:#9db1bf}
.connection b,.connectionActive b{color:#bfad81;font-size:9px}
.chat{
  display:grid;
  grid-template-rows:auto minmax(0,1fr) auto;
  min-width:0;
  background:rgb(7 22 42 / 48%);
}
.chat>header{
  display:grid;
  grid-template-columns:54px minmax(0,1fr) auto;
  gap:10px;
  align-items:center;
  min-height:70px;
  padding:9px 14px;
  border-bottom:1px solid rgb(255 255 255 / 10%);
}
.chat>header>div{display:grid}
.chat>header small{color:#9db0bd}
.chat>header b{color:#bfad81;font-size:9px}
.chatEmpty{
  display:grid;
  place-content:center;
  text-align:center;
  padding:40px;
  color:#a5b7c3;
}
.chatEmpty>span{font-size:42px}
.chatEmpty h2{margin:8px 0 3px;color:#fff}
.messages{
  display:flex;
  flex-direction:column;
  gap:8px;
  overflow:auto;
  padding:22px;
}
.messageMine,.messageOther{
  width:fit-content;
  max-width:min(76%,560px);
  padding:9px 11px;
  border-radius:14px;
}
.messageMine{align-self:flex-end;background:#264f6a}
.messageOther{align-self:flex-start;background:#18324b}
.messageOther strong{display:block;color:#bfad81;font-size:9px}
.messageMine p,.messageOther p{margin:3px 0;font-size:13px}
.messageMine time,.messageOther time{
  display:block;
  text-align:right;
  color:#9fb0bc;
  font-size:9px;
}
.composer{
  display:grid;
  grid-template-columns:minmax(0,1fr) auto;
  gap:8px;
  padding:10px;
  border-top:1px solid rgb(255 255 255 / 10%);
}
.composer label{
  position:absolute;
  width:1px;
  height:1px;
  overflow:hidden;
  clip:rect(0 0 0 0);
}
.composer textarea{
  min-height:46px;
  resize:none;
  border:1px solid rgb(255 255 255 / 13%);
  border-radius:23px;
  padding:11px 14px;
  background:rgb(255 255 255 / 7%);
  color:#fff;
}
.composer button{
  width:46px;
  height:46px;
  border:0;
  border-radius:50%;
  background:#526e94;
  color:#fff;
}
.directoryList{
  display:grid;
  margin-top:10px;
}
.directoryList article{
  display:grid;
  grid-template-columns:54px minmax(0,1fr) auto auto;
  gap:12px;
  align-items:center;
  padding:13px 4px;
  border-bottom:1px solid rgb(255 255 255 / 8%);
}
.directoryList article>div{display:grid;gap:3px;min-width:0}
.directoryList article>div>strong{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.directoryList small{color:#9db1bf}
.directoryList em{
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  color:#bfd0dc;
  font-size:11px;
  font-style:normal;
}
.directoryList article>b{
  padding:6px 9px;
  border:1px solid rgb(191 173 129 / 24%);
  border-radius:999px;
  color:#bfad81;
  font-size:9px;
  white-space:nowrap;
}
.directoryList article>button{
  min-height:40px;
  padding:0 14px;
  border:1px solid rgb(255 255 255 / 14%);
  border-radius:14px;
  background:linear-gradient(120deg,rgb(48 92 145 / 80%),rgb(48 73 93 / 86%));
  color:#fff;
  font-size:9px;
  font-weight:700;
}
.directoryList article>button:disabled{
  background:rgb(255 255 255 / 6%);
  color:#9fb2bf;
}
.loadMore{
  display:block;
  min-height:44px;
  margin:18px auto;
  padding:0 22px;
  border:1px solid rgb(255 255 255 / 14%);
  border-radius:16px;
  background:rgb(255 255 255 / 7%);
  color:#fff;
}
.activityPage>div{
  display:grid;
  grid-template-columns:repeat(3,1fr);
  gap:10px;
}
.activityPage article{
  min-height:160px;
  display:grid;
  align-content:end;
  padding:18px;
  border:1px solid rgb(255 255 255 / 12%);
  border-radius:22px;
  background:rgb(255 255 255 / 6%);
}
.activityPage article strong{font-size:34px;color:#bfad81}
.activityPage article span{color:#aebfca}
.bottomNav{
  position:fixed;
  z-index:75;
  left:50%;
  bottom:max(8px,env(safe-area-inset-bottom));
  transform:translateX(-50%);
  width:min(560px,calc(100% - 20px));
  display:grid;
  grid-template-columns:repeat(5,1fr);
  gap:4px;
  padding:8px;
  border:1px solid rgb(255 255 255 / 16%);
  border-radius:24px;
  background:rgb(12 27 55 / 84%);
  backdrop-filter:blur(24px);
  box-shadow:0 16px 38px rgb(0 0 0 / 35%);
}
.bottomNav button,.bottomNav a{
  min-height:52px;
  display:grid;
  place-items:center;
  align-content:center;
  gap:2px;
  border:0;
  border-radius:17px;
  background:transparent;
  color:#aebfd0;
  text-decoration:none;
  font-size:18px;
}
.bottomNav span{font-size:8px}
.bottomNav .bottomActive{
  background:radial-gradient(circle at 50% 25%,rgb(64 112 170 / 55%),rgb(32 66 100 / 18%));
  color:#fff;
}
button:focus-visible,a:focus-visible,input:focus-visible,textarea:focus-visible{
  outline:3px solid #bfad81;
  outline-offset:2px;
}
@media(prefers-reduced-motion:reduce){
  .scrollActionBar,.scrollActionBarSettling{transition:none}
}
@media(max-width:820px){
  .appBar{
    grid-template-columns:auto 1fr auto;
    padding-inline:12px;
  }
  .brand strong{font-size:19px}
  .brand span{font-size:8px}
  .mutualLayout{grid-template-columns:1fr}
  .mutualList{border-right:0;border-bottom:1px solid rgb(255 255 255 / 10%)}
  .chat{min-height:500px}
  .opportunityGrid{grid-template-columns:1fr}
  .mixedList{grid-template-columns:1fr}
  .collectionOverview{grid-template-columns:1fr 1fr}
  .activityPage>div{grid-template-columns:1fr 1fr}
}
@media(max-width:560px){
  .shell{padding-top:68px}
  .appBar{
    min-height:68px;
    grid-template-columns:auto minmax(0,1fr) 40px;
    gap:7px;
  }
  .brand strong{font-size:17px}
  .brand span{font-size:7px}
  .search{grid-template-columns:minmax(0,1fr) 38px}
  .search input{min-height:40px;font-size:16px;padding-inline:10px}
  .search button,.menuButton{min-height:38px}
  .navigationStack{top:68px;width:100%;padding-inline:8px}
  .modeSwitch button,.homeSubnav button{font-size:10px}
  .feedViewport,.story{height:calc(100dvh - 68px);min-height:calc(100dvh - 68px)}
  .storyTopline{top:145px;left:12px;right:12px}
  .storyCopy{left:16px;right:16px;bottom:170px}
  .storyCopy h1{font-size:42px}
  .agencyPanel{left:10px;right:10px;bottom:174px;padding:13px}
  .agencyPanel h1{font-size:34px}
  .scrollActionBar,.scrollActionBarSettling{
    bottom:88px;
    width:calc(100vw - 24px);
  }
  .scrollActionBar button,.scrollActionBarSettling button{min-height:54px}
  .scrollActionBar button b,.scrollActionBarSettling button b{font-size:7px}
  .collectionsPage,.directoryPage,.activityPage,.opportunities{
    width:100%;
    padding-inline:10px;
  }
  .collectionsHero,.directoryPage>header{
    align-items:flex-start;
    padding:14px;
  }
  .collectionsHero h1,.directoryPage>header h1{font-size:34px}
  .collectionOverview{grid-template-columns:1fr}
  .mixedList article{grid-template-columns:112px minmax(0,1fr)}
  .mixedThumb{min-height:132px}
  .directoryList article{
    grid-template-columns:44px minmax(0,1fr) auto;
    gap:8px;
  }
  .directoryList article>b{grid-column:2}
  .directoryList article>button{grid-column:3;grid-row:1/3;padding-inline:9px}
  .activityPage>div{grid-template-columns:1fr}
  .bottomNav{bottom:max(6px,env(safe-area-inset-bottom));width:calc(100% - 12px)}
  .bottomNav button,.bottomNav a{min-height:50px;font-size:16px}
}


.storyTopActions{display:flex;align-items:center;gap:7px}.profilePeek{width:34px;height:34px;border:1px solid rgb(255 255 255 / 16%);border-radius:999px;background:rgb(7 21 45 / 62%);color:#fff;backdrop-filter:blur(14px)}
.directoryActions{display:flex;gap:6px}.directoryActions button{min-height:40px;padding:0 12px;border:1px solid rgb(255 255 255 / 14%);border-radius:14px;background:rgb(255 255 255 / 7%);color:#fff;font-size:9px;font-weight:700}.directoryActions button:last-child{background:linear-gradient(120deg,rgb(48 92 145 / 80%),rgb(48 73 93 / 86%))}.directoryActions button:disabled{background:rgb(255 255 255 / 6%);color:#9fb2bf}
.profileLoading{position:fixed;z-index:102;inset:86px auto auto 50%;transform:translateX(-50%);padding:12px 16px;border:1px solid rgb(255 255 255 / 14%);border-radius:16px;background:rgb(7 21 45 / 92%);color:#fff;backdrop-filter:blur(20px)}
.profilePreview{position:fixed;z-index:100;inset:0;overflow:auto;background:linear-gradient(160deg,#07152d,#0b2346 48%,#07162d);color:#fff}
.profileCover{position:relative;min-height:410px;display:flex;align-items:flex-end;padding:32px max(20px,calc((100vw - 1080px)/2));background-size:cover;background-position:center}
.profileClose{position:absolute;top:20px;left:max(20px,calc((100vw - 1080px)/2));width:44px;height:44px;border:1px solid rgb(255 255 255 / 18%);border-radius:999px;background:rgb(6 20 38 / 55%);color:#fff;font-size:20px;backdrop-filter:blur(14px)}
.profileIdentity{display:grid;grid-template-columns:86px minmax(0,1fr);gap:16px;align-items:end}.profileIdentity .avatar{width:82px;height:82px;font-size:24px}.profileIdentity p{margin:0;color:#bfad81;font-size:10px;letter-spacing:.12em;text-transform:uppercase}.profileIdentity h1{margin:5px 0;font-family:Georgia,serif;font-size:clamp(40px,6vw,68px);font-weight:500;line-height:.98}.profileIdentity>div>span{color:#c7d5df}
.profileTabs{position:sticky;top:0;z-index:2;width:min(1080px,100%);margin:0 auto;display:grid;grid-template-columns:repeat(3,1fr);border-bottom:1px solid rgb(255 255 255 / 10%);background:rgb(8 24 45 / 88%);backdrop-filter:blur(18px)}.profileTabs button{position:relative;min-height:56px;border:0;background:transparent;color:#9fb3c2}.profileTabs button[aria-pressed=true]{color:#fff}.profileTabs button[aria-pressed=true]::after{content:"";position:absolute;left:24%;right:24%;bottom:0;height:3px;background:#bfad81}
.profileAgency,.profileInventory,.profileBlog{width:min(1080px,calc(100% - 28px));margin:16px auto 80px}.profileAgency{display:grid;grid-template-columns:minmax(0,1.5fr) minmax(260px,.6fr);gap:12px}.profileAgency>section,.profileAgency>aside,.profileInventory article,.profileBlog article{border:1px solid rgb(255 255 255 / 11%);border-radius:20px;background:rgb(255 255 255 / 5%);backdrop-filter:blur(16px)}.profileAgency>section,.profileAgency>aside{padding:20px}.profileAgency>section>p{margin:0;color:#bfad81;font-size:9px;letter-spacing:.13em}.profileAgency h2{margin:5px 0 8px;font-family:Georgia,serif;font-weight:500}.profileAgency>section>span,.profileAgency aside p{color:#aebfca;line-height:1.55}.profileAgency dl{margin:14px 0}.profileAgency dl>div{display:grid;grid-template-columns:100px minmax(0,1fr);gap:8px;padding:8px 0;border-bottom:1px solid rgb(255 255 255 / 8%)}.profileAgency dt{color:#8fa5b3}.profileAgency dd{margin:0}.profileAgency aside strong{color:#bfad81}
.profileInventory{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:10px}.profileInventory article{min-height:190px;display:grid;align-content:end;gap:5px;padding:18px;background:linear-gradient(145deg,rgb(31 72 98 / 52%),rgb(8 26 50 / 72%))}.profileInventory small,.profileBlog small{color:#bfad81;font-size:8px;letter-spacing:.12em}.profileInventory h2,.profileBlog h2{margin:0;font-family:Georgia,serif;font-weight:500}.profileInventory strong{font-size:20px}.profileInventory span{color:#9eb2c0;font-size:10px}
.profileBlog{display:grid;gap:10px}.profileBlog article{padding:20px}.profileBlog h2{margin-top:6px;font-size:28px}.profileBlog article>strong{display:block;margin:6px 0;color:#c7d5df}.profileBlog p{color:#aebfca;line-height:1.65;white-space:pre-wrap}
@media(max-width:720px){.directoryActions{grid-column:3;grid-row:1/3;flex-direction:column}.directoryActions button{padding-inline:8px}.profileCover{min-height:350px;padding:24px 16px}.profileClose{left:14px}.profileIdentity{grid-template-columns:66px minmax(0,1fr)}.profileIdentity .avatar{width:64px;height:64px;font-size:19px}.profileIdentity h1{font-size:36px}.profileAgency{grid-template-columns:1fr}.profileInventory{grid-template-columns:1fr}.profileAgency,.profileInventory,.profileBlog{width:calc(100% - 20px)}}
